import React, { useState } from "react";
import Cropper from "react-easy-crop";
import getCroppedImg from "../../utils/cropImage";
import Dialog from ".";

export default function DialogCropper({
  open,
  image,
  onClose,
  onComplete,
  isLoading,
}) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const handleCropComplete = (_, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  };

  const handleDone = async () => {
    const croppedImage = await getCroppedImg(
      image,
      croppedAreaPixels,
      rotation
    );
    onComplete(croppedImage);
  };

  return (
    <Dialog open={open} onClose={onClose} width={"576px"}>
      <div className="bg-white w-full">
        <h3 className="text-lg font-semibold mb-4">Crop Photo</h3>
        <div className="relative w-full h-[300px] bg-gray-200">
          <Cropper
            image={image}
            crop={crop}
            zoom={zoom}
            rotation={rotation}
            aspect={1}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onRotationChange={setRotation}
            onCropComplete={handleCropComplete}
          />
        </div>

        <div className="flex gap-4 items-center mt-4">
          <label className="text-sm">Zoom</label>
          <input
            type="range"
            min={1}
            max={3}
            step={0.1}
            value={zoom}
            onChange={(e) => setZoom(e.target.value)}
          />
          <label className="text-sm">Rotate</label>
          <input
            type="range"
            min={0}
            max={360}
            step={1}
            value={rotation}
            onChange={(e) => setRotation(e.target.value)}
          />
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={handleDone}
            disabled={isLoading}
            className="w-full relative overflow-hidden !py-3 !font-bold !text-lg !bg-[#007A78]"
          >
            {isLoading ? "Uploading..." : "Done"}
          </button>

          <button
            onClick={onClose}
            className="w-full relative overflow-hidden !py-3 !font-bold !text-lg !ring-1 !bg-transparent !text-[#007A78] !ring-[#007A78]"
          >
            Cancel
          </button>
        </div>
      </div>
    </Dialog>
  );
}
